/**
 * 机器人草稿（在线编辑）接口，对齐后端 OpenAPI：
 * - 协同：进入 join / 退出 leave（无 token 概念，按用户身份 + 缓存标记 + 2h 过期）
 * - 同步：PUT sync-online-config（线上 → 草稿）
 * - 发布：直接走 robotsApi.update + publish_status=2，本文件不负责
 *
 * leave 用 silent，避免退出场景污染页面 toast；join 失败时由 store 兜底降级。
 */
import { apiPost, apiPut, apiRequest } from '@/utils/request';
import type { OnlineEditorJoinResp, OnlineEditorLeaveResp } from '@/types/robotDraft';

export const robotDraftApi = {
  /** 进入草稿编辑页：写在线状态，返回在线编辑人数（含自身）；2h 无操作过期 */
  onlineEditorJoin: (robotId: number) =>
    apiPost<OnlineEditorJoinResp>(`/robots/${robotId}/online-editor/join`, {}),

  /** 退出草稿编辑页：删除自身在线标记，返回剩余人数 */
  onlineEditorLeave: (robotId: number) =>
    apiRequest<OnlineEditorLeaveResp>(`/robots/${robotId}/online-editor/leave`, {
      method: 'POST',
      data: {},
      silent: true,
    }),

  /** 用线上配置覆盖草稿（version_type=1） */
  syncOnlineConfig: (robotId: number) =>
    apiPut<unknown>(`/robots/${robotId}/sync-online-config`, {}),
};
